import { atom, useAtom } from 'jotai'

export const atomLoader = atom(0)

export const useGlobalLoader = () => {
    const [loaders, setLoaders] = useAtom(atomLoader)

    return {
        incrementLoader: () => {
            setLoaders((l) => l + 1)
        },
        decrementLoader: () => {
            setLoaders((l) => l - 1)
        },
        isLoading: loaders > 0,
    }
}
